import { render, staticRenderFns } from "./AddBannerPage.vue?vue&type=template&id=00620f7a&scoped=true&"
import script from "./AddBannerPage.vue?vue&type=script&lang=js&"
export * from "./AddBannerPage.vue?vue&type=script&lang=js&"
import style0 from "./AddBannerPage.vue?vue&type=style&index=0&id=00620f7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00620f7a",
  null
  
)

export default component.exports